/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
  addEvent({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/user/calendar/create", payload)
        .then((response) => {
          // commit('ADD_EVENT',))
          if(response.data.result == 'success'){
            commit('ADD_EVENT', response.data.data)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getEvent({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/user/calendar/"+ payload)
        .then((response) => {
          if(response.data.result == 'success'){
            commit('SET_EVENTS', response.data.data_list)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  editEvent({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/user/calendar/update", payload)
        .then((response) => {
          if(response.data.result == 'success'){
            commit('UPDATE_EVENT', response.data.data)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeEvent({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.delete("/api/user/calendar/delete/"+payload)
        .then((response) => {
          if(response.data.result == 'success'){
            commit('REMOVE_EVENT', payload)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  eventDragged({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/user/calendar/update", payload)
        .then((response) => {
          if(response.data.result == 'success'){
            commit('UPDATE_EVENT', payload)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => { reject(error) })
    })
  },
}
